import { ApolloClients } from "./ApolloClients";
export const askrClients = new ApolloClients("askr");
